import { imeiAPI } from '../api/client'

type ReportRow = { id: number }

function storageKey(userId: number): string {
  return `redevicer:imei-reports-seen:${userId}`
}

export function markReportsSeen(userId: number, reports: ReportRow[]): void {
  const maxId = reports.reduce((max, row) => Math.max(max, row.id), 0)
  if (maxId <= 0) return
  try {
    localStorage.setItem(storageKey(userId), String(maxId))
  } catch {
    /* ignore quota / private mode */
  }
}

export function countUnreadReports(userId: number, reports: ReportRow[]): number {
  let seenRaw: string | null = null
  try {
    seenRaw = localStorage.getItem(storageKey(userId))
  } catch {
    return 0
  }

  if (seenRaw == null) {
    markReportsSeen(userId, reports)
    return 0
  }

  const seen = parseInt(seenRaw, 10)
  if (!Number.isFinite(seen)) {
    markReportsSeen(userId, reports)
    return 0
  }

  return reports.filter((row) => row.id > seen).length
}

export async function fetchImeiReportsUnreadCount(token: string, userId: number): Promise<number> {
  try {
    const res = await imeiAPI.listReports(token)
    const reports = (res.data as ReportRow[]) ?? []
    return countUnreadReports(userId, reports)
  } catch {
    return 0
  }
}

export function notifyImeiReportsUpdated(unread?: number): void {
  window.dispatchEvent(
    new CustomEvent('redevicer:imei-reports-updated', {
      detail: unread != null ? { unread } : undefined,
    }),
  )
}
